import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("lu-loader")
export class LuLoader extends LitElement {
  @property({ type: String })
  size: string = "24";

  @property({ type: String })
  color: string = "currentColor";

  @property({ type: Number })
  strokeWidth: number = 1.75; // default from lucide

  @property({ type: Boolean })
  absoluteStrokeWidth: boolean = false;

  @property({ type: Boolean })
  mirrored: boolean = false;

  static override styles = css`
    :host {
      display: contents;
    }
  `;

  override render() {
    return html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="${this.size}"
        height="${this.size}"
        viewBox="0 0 24 24"
        fill="none"
        stroke="${this.color}"
        stroke-width="${this.absoluteStrokeWidth ? this.strokeWidth : (this.strokeWidth * 24) / parseInt(this.size)}"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        ${this.mirrored ? html`<g transform="scale(-1, 1) translate(-24, 0)"></g>` : ""}
        <path d="M12 2v4" />
        <path d="m16.2 7.8 2.9-2.9" />
        <path d="M18 12h4" />
        <path d="m16.2 16.2 2.9 2.9" />
        <path d="M12 18v4" />
        <path d="m4.9 19.1 2.9-2.9" />
        <path d="M2 12h4" />
        <path d="m4.9 4.9 2.9 2.9" />
        ${this.mirrored ? html`</g>` : ""}
      </svg>
    `;
  }
}
